/**
 * Wann der Wert eines Faelligkeits-`<input type="date">` als Eingabe gilt. Ein solches Feld meldet je getipptem Segment
 * ein Zwischendatum ("0002-01-15" nach der ersten Jahresziffer, "20261-12-31" bei zu vielen Ziffern); nur `JJJJ-MM-TT` ab
 * 1900 darf zum Server (Vorfall Asana 1218053584680823, siehe `components/Drawer/Datumsfeld.tsx`). Neu seit der
 * Sammelsendungs-Faelligkeit, kein Teil der Portierung aus `index.html`.
 */
export const FRUEHESTES_FAELLIGKEITSDATUM = "1900-01-01";

const DATUMSFORM = /^\d{4}-\d{2}-\d{2}$/;

export function istGueltigesFaelligkeitsdatum(wert: string): boolean {
  return DATUMSFORM.test(wert) && wert >= FRUEHESTES_FAELLIGKEITSDATUM;
}
